import "./App.css";
import React, { useState } from "react";

const initData = [
  {
    title: "Winnie",
    color: "rgb(142,110,149)",
    todos: ["Do homework", "Do laundry"],
  },
  {
    title: "Bob",
    color: "rgb(57,165,156)",
    todos: ["Play video games", "Level up"],
  },
  {
    title: "Thomas",
    color: "rgb(52,71,89)",
    todos: ["get gurls", "Go to school"],
  },
  {
    title: "George",
    color: "rgb(232,116,30)",
    todos: ["Cheat on exam", "Fool around"],
  },
];

function App() {
  const [data, setData] = useState(initData);
  const addTodo = (index) => {
    const newTodo = prompt("What do you want to do?");
    const nextData = [...data];
    nextData[index].todos.push(newTodo);
    setData(nextData);
  };
  return (
    <div className="App">
      {data.map((v, i) => {
        return (
          <div className="column" key={i}>
            <div className="header" style={{ backgroundColor: v.color }}>
              <span>{v.title}</span>
            </div>
            <div className="list">
              {v.todos.map((w, j) => {
                return (
                  <div key={j} className="todo">
                    {i === 0 ? "" : <button>Prev</button>}
                    <span>{w}</span>
                    {i === 3 ? "" : <button>Next</button>}
                  </div>
                );
              })}
            </div>
            <button onClick={() => addTodo(i)}>Add new todo</button>
          </div>
        );
      })}
    </div>
  );
}

export default App;
